export enum LiabilityTypeOption {
	AccountsPayable = 'Accounts Payable',
	TaxesOwed = 'Taxes Owed',
	Other = 'Other',
}